import React from "react";
import { useHistory, useParams } from "react-router-dom";
import EmployeeAuditTrail from "./AuditTrailTab/EmployeeAuditTrail";
import StudentAuditTrail from "./AuditTrailTab/StudentAuditTrail";
import CallLogs from "../../../systemadministration/SoftphoneManagement/CallLogs";
import PermissionsGate from "../../../../utils/permissionGate";

function AuditTrail({ studentName }) {
  const history = useHistory();
  const { tab, id, subType } = useParams();
  return (
    <div>
      <div className="tabs-wrap">
        <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
          <li
            className="nav-item ml-1"
            onClick={() =>
              history.push(
                `/studentAdministration/students/open/${id}/auditTrail/employee`
              )
            }
          >
            <a
              className={`nav-link cursor-pointer ${
                subType === "employee" ? "active" : ""
              }`}
              id="pills-tab1"
              data-toggle="pill"
              role="tab"
              aria-controls="pills-tab11"
              aria-selected="true"
            >
              <i className="fal fa-history"></i>
              Employee Audit Trail
            </a>
          </li>
          <li
            className="nav-item"
            onClick={() =>
              history.push(
                `/studentAdministration/students/open/${id}/auditTrail/student`
              )
            }
          >
            <a
              className={`nav-link cursor-pointer ${
                subType === "student" ? "active" : ""
              }`}
              id="pills-tab2"
              data-toggle="pill"
              role="tab"
              aria-controls="pills-tab12"
              aria-selected="true"
            >
              <i className="fal fa-history"></i>Student Audit Trail
            </a>
          </li>
          <PermissionsGate scopes={['studentaudittrialcalllogview']}
          RenderError={ () => null}
          >

          <li
            className="nav-item"
            onClick={() =>
              history.push(
                `/studentAdministration/students/open/${id}/auditTrail/callLogs`
              )
            }
          >
            <a
              className={`nav-link cursor-pointer ${
                subType === "callLogs" ? "active" : ""
              }`}
              id="pills-tab1"
              data-toggle="pill"
              role="tab"
              aria-controls="pills-tab11"
              aria-selected="true"
            >
              <i className="fal fa-phone-office"></i>
              Call Logs
            </a>
          </li>
              </PermissionsGate>
        </ul>

        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade active show"
            id="pills-tab11"
            role="tabpanel"
            aria-labelledby="pills-tab1"
          >
            {tab === "auditTrail" && subType == "employee" && (
              <EmployeeAuditTrail />
            )}
          </div>
          <div
            className="tab-pane fade active show"
            id="pills-tab12"
            role="tabpanel"
            aria-labelledby="pills-tab2"
          >
            {tab === "auditTrail" && subType == "student" && (
              <StudentAuditTrail />
            )}
          </div>
          <div
            className="tab-pane fade active show"
            id="pills-tab12"
            role="tabpanel"
            aria-labelledby="pills-tab2"
          >
            {tab === "auditTrail" && subType == "callLogs" && (
              <CallLogs onPage={"student"}/>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuditTrail;
